import { ChevronLeftIcon } from "../../icons";

type BackBreadcrumbProps = {
  onClick: () => void;
};
const BackBreadcrumb = ({ onClick }: BackBreadcrumbProps) => {
  return (
    <div
      className="flex items-center text-sm font-medium text-gray-500 hover:text-gray-700 hover:cursor-pointer"
      onClick={onClick}
    >
      <ChevronLeftIcon className="flex-shrink-0 -ml-1 mr-1 h-4 w-4 text-gray-400" />
      Back
    </div>
  );
};

export default BackBreadcrumb;
